import React, { useEffect, useCallback, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core'
import { connect } from 'react-redux'
import { CountriesActions } from 'redux/actions';
import { AnTable, AnTableToolbar } from 'components/an'
import { Breadcrumb, ErrorBox } from 'components'
import PublicIcon from '@material-ui/icons/Public'
import { withQueryParams, StringParam, NumberParam, withDefault } from 'use-query-params';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
    },
  },
  content: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    
    [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(3),
    },
  },
  emptyIcon: {
    fontSize: '200px',
    color: '#ccc'
  }
}));

const CountriesList = props => {
    const {
        getCountries,
        countries,
        country,
        initialLoading,
        loading,
        error,
        totals,
        page,
        pageCount,
        isActiveSearch,
        saveCountry,
        query,
        setQuery,
        reset
    } = props

    const {
        p,
        r,
        q,
    } = query;
    
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        // Nothing to do, we only use this effect
        // to register the function thats makes the cleanup
        // when the component unmount
        return () => {
            reset('COUNTRIES_RESET')
        }
    }, [reset])

    useEffect(() => {
        if (q.length > 2) {
            getCountries(p, r, q)
        } else if (q.length === 0) {
            getCountries(p, r)
        }
    }, [p, r, q, getCountries])
    
    const onSearch = useCallback((text) => {
        if (text.length > 2) {
            setQuery({ q: text, p: undefined })
        } else {
            setQuery({ q: undefined, p: undefined })
        }
    }, [setQuery])

    const onClickEdit = useCallback((id) => {
        history.push(`/paises/editar/${id}`);
    }, [history])

    const onClickToggleActivate = useCallback((id, inactive)=> {
        saveCountry(id, { inactivo: !inactive }, true)
    }, [saveCountry])

    const onPageChange = useCallback((page) => {
        setQuery({ p: page > 0 ? page : undefined })
    }, [setQuery])

    const onPageCountChange = useCallback((pageCount) => {
        setQuery({ r: pageCount !== 10 ? pageCount : undefined })
    }, [setQuery])

    const headers = useMemo(() => ([
        { label: 'País' },
    ]), [])

    const rows = useMemo(() => (
        countries.map(item => {
            return {
                view: [
                    { value: item.nombre },
                ],
                data: {
                    id: item.id,
                    inactive: item.inactivo,
                }
            }
        })
    ), [countries])
  
    return (
        <div className={classes.root}>
            <Breadcrumb
                path={[
                    {
                        name: 'Paises'
                    }
                ]}
            />
            
            <Box>
                {initialLoading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                    >
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <ErrorBox
                        onRetry={() => {
                            if (q.length > 2) {
                                getCountries(p, r, q)
                            } else if (q.length === 0) {
                                getCountries(p, r)
                            }
                        }}
                    />
                ) : (
                    <Box width="100%">
                        <div className={classes.content}>
                            <AnTable
                                toolbar={(
                                    <AnTableToolbar
                                        textSearchPlaceholder="Buscar país ...."
                                        textSearchValue={q}
                                        createButtonText="Crear País"
                                        createButtonTo="/paises/nuevo"
                                        onSearch={onSearch}
                                    />
                                )}
                                isActiveSearch={isActiveSearch}
                                emptyIcon={(
                                    <PublicIcon className={classes.emptyIcon} />
                                )}
                                emptyMessage="Aún no has creado ningún país"
                                emptyButtonTo="/paises/nuevo"
                                emptyButtonText="Crear País"
                                headers={headers}
                                rows={rows}
                                loading={loading}
                                save={country.actions.save}
                                totals={totals}
                                page={page}
                                pageCount={pageCount}
                                onClickEdit={onClickEdit}
                                onClickToggleActivate={onClickToggleActivate}
                                onPageChange={onPageChange}
                                onPageCountChange={onPageCountChange}
                            />
                        </div>
                    </Box>
                )}
            </Box>
        </div>
    );
};

const mapStateToProps = state => ({
    initialLoading: state.countries.initialLoading,
    loading: state.countries.loading,
    error: state.countries.error,
    countries: state.countries.data,
    page: state.countries.page,
    pageCount: state.countries.pageCount,
    totals: state.countries.totals,
    isActiveSearch: state.countries.isActiveSearch,
    country: state.countries.country,
})

const mapDispatchToProps = dispatch => ({
    getCountries: (page, pageCount, criteria) => dispatch(CountriesActions.getCountries(page, pageCount, criteria)),
    saveCountry: (id, data, patch) => dispatch(CountriesActions.saveCountry(id, data, patch)),
    reset: (type) => dispatch(CountriesActions.reset(type))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    withQueryParams({
        p: withDefault(NumberParam, 0), // The current page
        r: withDefault(NumberParam, 10), // The current page count
        q: withDefault(StringParam, "") // The current search criteria
    }, CountriesList)
);
